<script setup>
import { computed } from 'vue'
import Highlight from './Highlight.vue'
import { Tooltip } from 'dmui_components'

const props = defineProps({
	text: {
		type: String,
		default: ''
	},
	highlights: {
		type: Array,
		default: () => []
	},
	term_id: {
		type: Number,
		default: undefined
	},
	type: {
		type: String,
		default: undefined
	}
})

function mergeHighlights(highlights) {
	const mergedHighlights = []
	for (let highlight of highlights) {
		mergedHighlights.push(highlight)
	}
	return mergedHighlights
}

function highlightText(text, highlights) {
	const tokens = []
	let processedEnd = 0

	highlights.sort((a, b) => a.segment_start - b.segment_start)
	for (let highlight of highlights) {
		if (highlight.segment_start - processedEnd > 0) {
			tokens.push({
				type: 'text',
				text: text.substring(processedEnd, highlight.segment_start)
			})
		}

		tokens.push({
			...highlight,
			type: 'annotation',
			text: text.substring(highlight.segment_start, highlight.segment_end)
		})

		processedEnd = highlight.segment_end
	}

	if (processedEnd < text.length) {
		tokens.push({
			type: 'text',
			text: text.substring(processedEnd)
		})
	}
	return tokens
}

function getAnnotationColorClass(token) {
	if (props.type == 'NLP') {
		const termIdList = token?.termIds || [token.term_id]
		return termIdList[0] % 8
	} else if (props.term_id) {
		if (token.termIds.includes(props.term_id)) {
			const count = token.termIds.filter((id) => id !== props.term_id).length
			return count > 0 ? 'main-secondary' : 'main'
		} else {
			return 'secondary'
		}
	} else {
		return 'main'
	}
}

const mergedHighlights = computed(() => mergeHighlights(props.highlights || []))
const tokens = computed(() => highlightText(props.text, mergedHighlights.value))
</script>

<template>
	<div class="primary-text">
		<template v-for="(token, index) in tokens" :key="index">
			<span v-if="token.type === 'text'">{{ token.text }}</span>
			<Tooltip v-else position="top">
				<Highlight :class="`annotation-${getAnnotationColorClass(token)}`">{{ token.text }}</Highlight>
				<template #tooltip>{{ token.term_text }}</template>
			</Tooltip>
		</template>
	</div>
</template>

<style lang="less" scoped>
.primary-text {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 0px 4px;
}
</style>
